import hash from 'object-hash';

const generateKeyedArray = (array = []) => {
  return array.map((item, index) => ({ item, key: `${hash(item)}_${index}` }));
};

const generateHashCode = (value) => {
  let hash = 0;
  if (value.length === 0) {
    return hash;
  }

  for (let i = 0; i < value.length; i++) {
    const c = value.charCodeAt(i);
    hash = ((hash << 5) - hash) + c;
    hash = hash & hash;
  }

  return hash;
};

// code from https://gist.github.com/jed/982883
const generateUUID = (prefix) => {
  if (window.crypto) {
    const correlationId = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => {
      return (((c ^ crypto.getRandomValues(new Uint8Array(1))[0]) & 15) >> c / 4).toString(16);
    });

    return prefix ? `${prefix}_${correlationId}` : correlationId;
  }
};

export { generateKeyedArray, generateHashCode, generateUUID };
